export default __webpack_public_path__ + "static/media/STEMadium_WebInstructions_1.f17ab9c7.png";